import classNames from 'classnames';
import * as React from 'react';
import styles from './ActivityIndicator.module.css';

export interface ActivityIndicatorProps {
    cover?: boolean;
    active?: boolean;
    modal?: boolean;
    children?: string | React.ReactNode;
}

const ModalWrapper: React.FC<React.PropsWithChildren<{ visible?: boolean }>> = props => {
    const { visible, children } = props;

    return (
        <span className={styles.Outer} style={{ display: visible ? 'block' : 'none' }}>
            {children}
        </span>
    );
};

export const ActivityIndicator: React.FC<React.PropsWithChildren<ActivityIndicatorProps>> = React.memo(props => {
    const { modal = true, cover, active = true, children } = props;

    const Wrapper = modal ? ModalWrapper : React.Fragment;
    const wrapperProps = modal ? { visible: active } : {}; // react.Fragment cannot have any props

    return (
        <Wrapper {...wrapperProps}>
            <span
                style={active ? undefined : { display: 'none' }}
                className={classNames(styles.Inner, cover && styles['Inner--cover'])}
            />
            {children && (
                <span className={classNames(styles.Children, cover && styles['Inner--cover'])}>{children}</span>
            )}
        </Wrapper>
    );
});
